define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_profile/validate_cc_form",

        validation: {
            cc_front:{
                required: true
            },
            cc_back:{
                required: true
            },
            holder_name:{
                required: true
            },
            first_number:{
                required: true,
                length: 1,
                pattern: 'digits'
            },
            last_numbers:{
                required: true,
                length: 4,
                pattern: 'digits'
            },
            expiration_year:{
                required: true,
                length: 4,
                pattern: 'digits'
            },
            expiration_month:{
                required: true,
                length: 2,
                pattern: 'digits',
                range: [1, 12]
            }
        },

        labels: {
            cc_front: "Credit card front",
            cc_back: "Credit card back"
        }
    });
});
